import axios from "axios";
export default axios.create({
  baseURL: "/cp/",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});
